import $ from 'jquery';

// Функция инициализации переключателей даты и времени для оформления заказа
export default function initDateAndTimeControls() {
    $('input[data-target]')
        .change(function () {
            const $target = $($(this).data('target'));
            const $parent = $($target.data('parent'));
            const $children = $parent.find(`[data-parent='#${$parent.prop('id')}']`);

            $children
                .not($target)
                .hide()
                .find('input')
                .prop('disabled', true);

            $target
                .show()
                .find('input')
                .prop('disabled', false);
        });
}
